const buttons = () => [
  { id: 0, title: 'со всеми', image: 'net.svg' },
  { id: 1, title: 'с друзьями', image: 'friends.svg' },
  { id: 2, title: 'закрыв лицо', image: 'face.svg' },
  { id: 3, title: 'запросить разрешение', image: 'request.svg' },
  { id: 4, title: 'не делиться', image: 'not.svg' },
]

export default buttons()
